<script lang="ts">
	import type { BoutSummaryStats } from '../types';
	import SummaryColumn from './SummaryColumn.svelte';

	export let blue: BoutSummaryStats;
	export let red: BoutSummaryStats;
</script>

<div class="d-flex justify-content-between">
	<div class="empty-sidebar d-none d-sm-block" />
	<SummaryColumn summary={blue} corner="blue" />

	<SummaryColumn summary={red} corner="red" />
</div>
